import { Component, OnInit } from "@angular/core";
import { PrincipalService } from "../../services/principal.service";
import { CustomTranslationService } from "../../services/custom-translation.service";

@Component({
  selector: "app2-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  public wording
  constructor(private principal: PrincipalService, private customTranslate: CustomTranslationService) {
    this.wording = this.customTranslate.wording
  }

  ngOnInit(): void {
    this.isAuthenticated();
  }

  isAuthenticated() {
    return this.principal.isAuthenticated();
  }
}
